<template>
  <div>
    <!-- 搜索表单 -->
    <div class="right-panel">
      <div class="display">
        <CustomInput
          v-model="platForm.playerName"
          :options="currencyOptions"
          placeholder="Please select"
          label="player Name"
        />
        <CustomRangePicker v-model="dateRange" @close="onClose" />
      </div>
      <button
        class="export_button"
        :class="{ active: isExportEnabled }"
        :disabled="!isExportEnabled"
        @click="generationData"
      >
        Data generation
      </button>
    </div>

    <!-- 数据列表头 -->
    <div class="datalistall">
      <span class="dataList">Data list</span>
      <span class="dataListdetail"
        >The generated data is only retained for 30 days</span
      >
    </div>

    <!-- 数据区 -->
    <div>
      <!-- 有数据时 -->
      <div v-if="originalData.length" class="data-list-wrapper">
        <div class="data-list">
          <div
            v-for="(item, index) in originalData"
            :key="item.id || index"
            class="data-card"
          >
            <div class="data-card-top">
              <div class="data-card-info">
                <div class="data-card-header">{{ item.playerName }}</div>
                <div class="data-card-date">
                  {{ item.startTime }} — {{ item.endTime }}
                </div>
              </div>
              <div class="data-card-status">
                <span
                  v-if="item.status === -1 || item.status === 3"
                  class="status-text"
                >
                  {{ item.statusStr }}
                </span>
                <span
                  v-else-if="item.status === 0 || item.status === 1"
                  class="loading"
                >
                  loading...
                </span>
                <img
                  v-if="item.status === 2"
                  class="download-img"
                  @click="handleDownload(item)"
                  :src="imgDownload"
                  alt="imgDownload"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- 分页容器 -->
        <div class="pagination-wrapper">
          <el-pagination
            v-model:current-page="pageData.pageNum"
            background
            layout="prev, pager, next"
            :total="totalItems"
            :page-size="pageData.pageSize"
            @current-change="handlePageChange"
            style="--el-color-primary: #8e67ea"
          ></el-pagination>
        </div>
      </div>

      <!-- 无数据时 -->
      <div v-else class="nodata-wrapper">
        <img :src="imgNodata" alt="imgNodata" class="imgNodata" />
        <span class="dataListdetail">No content yet</span>
      </div>
    </div>
  </div>
</template>

<script setup>
import "@/styles/tablePageStyle.css";
import { ref, onMounted, watch, computed, onUnmounted } from "vue";
import CustomInput from "@/utils/CustomInput.vue";
import imgNodata from "@/assets/img_noData.svg";
import imgDownload from "@/assets/img_download.svg";
import CustomRangePicker from "@/utils/CustomRangePicker.vue";
import { ElMessage } from "element-plus";

import {
  playersPlaceBetsGenerateList,
  playersPlaceBetsGenerate,
} from "@/api/orderInformation";
const originalData = ref([]);
const totalItems = ref(0);
const dateRange = ref({ start: null, end: null });
const intervalId = ref(null); // 存放定时器 ID

const platForm = ref({
  playerName: "",
  startTime: "",
  endTime: "",
});
const pageData = ref({
  pageSize: 18,
  pageNum: 1,
});
const onClose = () => {
  console.log("弹窗关闭");
};
// 分页变化处理
const handlePageChange = (page) => {
  pageData.value.pageNum = page;
  fetchData();
};
const generationData = async () => {
  try {
    const response = await playersPlaceBetsGenerate(platForm.value);
    if (response.code === 200) {
      handlePageChange(1);
    } else {
      ElMessage.error(response.msg);
    }
  } catch (error) {
    originalData.value = [];
    console.error("失败:", error);
  }
};
const isExportEnabled = computed(() => {
  return (
    platForm.value.playerName &&
    platForm.value.startTime &&
    platForm.value.endTime
  );
});

const handleDownload = (item) => {
  if (item.isDownloading) return; // 防止连续点击
  item.isDownloading = true;

  // 模拟下载操作
  console.log("下载:", item.filePath);
  if (item.filePath) {
    // 创建 a 标签下载
    const link = document.createElement("a");
    link.href = item.filePath;
    link.download = item.filePath.split("/").pop(); // 设置下载文件名
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } else {
    console.error("未返回文件路径");
  }
  // 下载完成后，重置状态
  setTimeout(() => {
    item.isDownloading = false;
  }, 2000); // 2秒后可再次点击
};
const fetchData = async () => {
  try {
    const response = await playersPlaceBetsGenerateList(pageData.value);
    if (response.code === 200) {
      originalData.value = response.rows || [];
      totalItems.value = response.total;
    } else {
      originalData.value = [];
      ElMessage.error(response.msg);
    }
  } catch (error) {
    originalData.value = [];
    console.error("失败:", error);
  }
};

onMounted(() => {
  fetchData();
  // 每5秒钟刷新一次
  intervalId.value = setInterval(() => {
    fetchData();
  }, 5000);
});

onUnmounted(() => {
  if (intervalId.value) {
    clearInterval(intervalId.value);
  }
});

watch(
  dateRange,
  (newVal) => {
    console.log("dateRange changed:", newVal);
    if (newVal.start && newVal.end) {
      platForm.value.startTime = newVal.start;
      platForm.value.endTime = newVal.end;
      console.log("platForm updated:", platForm.value);
    }
  },
  { deep: true }
);
</script>

<style scoped>
.right-panel {
  flex: 38;
  padding: 24px;
  background: #ffffff;
  border-radius: 16px;
}
.display {
  display: flex;
  align-items: center;
  gap: 24px;
}
.export_button {
  border: none;
  background: none;
  margin-top: 31px;
  border-radius: 12px;
  color: #ffffff;
  font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, sans-serif;
  font-weight: 400;
  font-size: 12px;
  background-color: #ebe4fb; /* 默认灰一点 */
  line-height: 12px;
  letter-spacing: 0%;
  padding: 15px 36px;
  cursor: not-allowed; /* 默认不可点击 */
  display: flex;
  gap: 6px;
  align-items: center;
  transition: background-color 0.3s;
}

/* 启用状态 */
.export_button.active {
  background-color: #8e67ea; /* 改成启用时的颜色 */
  cursor: pointer;
}
.dataList {
  font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, sans-serif;
  font-weight: 500;
  font-size: 18px;
  font-style: Medium;
  line-height: 100%;
  letter-spacing: 0%;
  color: #333333;
}
.dataListdetail {
  font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #9fa1a8;
}
.datalistall {
  margin-top: 24px;
  display: flex; /* 关键 */
  align-items: center; /* 垂直居中对齐可选 */
  gap: 8px;
}
.nodata-wrapper {
  display: flex;
  flex-direction: column; /* 上下排列 */
  align-items: center; /* 水平居中 */
  justify-content: center; /* 垂直居中 (如果父容器有高度) */
  gap: 8px; /* 上下间隔 8px */
  margin-top: 40px; /* 可选，离上方内容留点空隙 */
  text-align: center;
}

.imgNodata {
  width: 78px; /* 建议给个固定宽度 */
  height: auto; /* 保持比例 */
  opacity: 1;
}
.data-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* 固定三列 */
  gap: 16px;
  margin-top: 20px;
}

.data-card {
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.data-card-header {
  color: #333;
  font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
}

.data-card-date {
  font-size: 12px;
  color: #9fa1a8;
  font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0%;
}

.data-card-status {
  font-size: 12px;
  margin-top: 4px;
}

.error {
  color: red;
}

.download {
  color: #8e67ea;
  cursor: pointer;
}
.data-card-top {
  display: flex;
  justify-content: space-between;
  align-items: center; /* header+date 与状态垂直居中对齐 */
}

.data-card-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.status-text {
  color: #ee3131;
  font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0%;
  text-align: right;
}

.loading {
  font-family: "Source Sans Pro", -apple-system, BlinkMacSystemFont, "Segoe UI",
    Roboto, "Helvetica Neue", Arial, sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #9fa1a8;
}
.data-list-wrapper {
  display: flex;
  flex-direction: column;
  gap: 20px; /* 表格和分页间距 */
}

.pagination-wrapper {
  text-align: center; /* 水平居中分页 */
}
</style>
